(function(){
  // 绑定事件
  $(window).scroll(function(){
    if(document.querySelector(".appDetail .protect-center")){
      // console.log($(document).scrollTop(),$(".protect-center").offset().top,123456789)
      if($(document).scrollTop() > $(".protect-center").offset().top){
        // $(".appDetail .protect-right").css("top",$(".protect-center").offset().top - $(document).scrollTop() + 'px')
        $(".appDetail .base-line").addClass("isFixed")
      }else{
        // $(".appDetail .protect-right").css("top",0)
        $(".appDetail .base-line").removeClass("isFixed")
      }
    }
    
  })
  // window.addEventListener("scroll",function(){
  //   var baseEle = document.querySelector(".appDetail .protect-center"),
  //       scrollEle = document.querySelector(".appDetail .protect-right")
  //   console.log(this.document.scrollTop)
  //   if(baseEle){
  //     if(document.scrollTop == 0){

  //     }
  //   }
  // })
})()


// WEBPACK FOOTER //
// ./static/scripts/rightBarScroll.js